export default __webpack_public_path__ + "static/media/subtitle-style-1.901a6046.webp";